import AgenliteAPIClient from '~/api/index';
import {
  FREE_ADMIN_FEE_JOIN_STATUS,
  FREE_ADMIN_FEE_MISSION_CONFIG_KEY,
  FREE_ADMIN_FEE_MISSION_PARAMS,
  FREE_ADMIN_FEE_SEGMENTATION_CONFIG_KEY,
} from '~/constants/vp/free-admin-fee-mission';

const initialState = {
  availableMissions: [],
  unavailableMissions: [],
  userMissions: [],
  segmentationConfig: {},
  missionConfig: {},
  loading: false,
  joining: false,
};

const getters = {
  getFreeAdminFeeAvailableMissions(state) {
    return state.availableMissions;
  },
  getFreeAdminFeeUnavailableMissions(state) {
    return state.unavailableMissions;
  },
  getFreeAdminFeeUserMissions(state) {
    return state.userMissions;
  },
  getFreeAdminFeeSegmentationConfig(state) {
    return state.segmentationConfig;
  },
  getFreeAdminFeeMissionConfig(state) {
    return state.missionConfig;
  },
  getFreeAdminFeeMissionLoading(state) {
    return state.loading;
  },
  getFreeAdminFeeMissionJoining(state) {
    return state.joining;
  },
};

const actions = {
  async fetchFreeAdminFeeAvailableMissions({ commit }) {
    try {
      const response = await AgenliteAPIClient.retrieveMissions({
        ...FREE_ADMIN_FEE_MISSION_PARAMS,
        available: true,
      });
      const missions = response?.data || [];
      commit('setFreeAdminFeeAvailableMissions', missions);
      return missions;
    } catch {
      commit('setFreeAdminFeeAvailableMissions', []);
      return [];
    }
  },

  async fetchFreeAdminFeeUnavailableMissions({ commit }) {
    try {
      const response = await AgenliteAPIClient.retrieveMissions({
        ...FREE_ADMIN_FEE_MISSION_PARAMS,
        available: false,
      });
      const missions = response?.data || [];
      commit('setFreeAdminFeeUnavailableMissions', missions);
      return missions;
    } catch {
      commit('setFreeAdminFeeUnavailableMissions', []);
      return [];
    }
  },

  async fetchFreeAdminFeeUserMissions({ commit }) {
    try {
      const response = await AgenliteAPIClient.retrieveMyMissions(FREE_ADMIN_FEE_MISSION_PARAMS);
      const missions = response?.data || [];
      commit('setFreeAdminFeeUserMissions', missions);
      return missions;
    } catch {
      commit('setFreeAdminFeeUserMissions', []);
      return [];
    }
  },

  async fetchFreeAdminFeeSegmentationConfig({ commit, dispatch }) {
    try {
      const neoResponse = await dispatch('fetchNeoConfigs', [FREE_ADMIN_FEE_SEGMENTATION_CONFIG_KEY]);
      const config = neoResponse?.[0]?.data || {};
      commit('setFreeAdminFeeSegmentationConfig', config);
      return config;
    } catch {
      commit('setFreeAdminFeeSegmentationConfig', {});
      return {};
    }
  },

  async fetchFreeAdminFeeMissionConfig({ commit, dispatch }) {
    try {
      const neoResponse = await dispatch('fetchNeoConfigs', [FREE_ADMIN_FEE_MISSION_CONFIG_KEY]);
      const payload = neoResponse?.[0]?.data || {};
      const config = payload.data || payload;
      commit('setFreeAdminFeeMissionConfig', config);
      return config;
    } catch {
      commit('setFreeAdminFeeMissionConfig', {});
      return {};
    }
  },

  async joinFreeAdminFeeMission({ commit, dispatch }, missionId: number | string) {
    commit('setFreeAdminFeeMissionJoining', true);

    try {
      await AgenliteAPIClient.updateMissionStatus(missionId, FREE_ADMIN_FEE_JOIN_STATUS);
      await Promise.all([dispatch('fetchFreeAdminFeeAvailableMissions'), dispatch('fetchFreeAdminFeeUserMissions')]);
    } catch (error) {
      dispatch('catchError', {
        message: 'Gagal mengikuti misi. Silakan coba lagi.',
      });
      throw error;
    } finally {
      commit('setFreeAdminFeeMissionJoining', false);
    }
  },

  async initFreeAdminFeeMissionData({ commit, dispatch }) {
    try {
      await Promise.all([
        dispatch('fetchFreeAdminFeeAvailableMissions'),
        dispatch('fetchFreeAdminFeeUnavailableMissions'),
        dispatch('fetchFreeAdminFeeUserMissions'),
      ]);
    } catch {
      commit('setFreeAdminFeeAvailableMissions', []);
      commit('setFreeAdminFeeUnavailableMissions', []);
      commit('setFreeAdminFeeUserMissions', []);
    }
  },
};

const mutations = {
  setFreeAdminFeeAvailableMissions(state, availableMissions) {
    state.availableMissions = availableMissions;
  },
  setFreeAdminFeeUnavailableMissions(state, unavailableMissions) {
    state.unavailableMissions = unavailableMissions;
  },
  setFreeAdminFeeUserMissions(state, userMissions) {
    state.userMissions = userMissions;
  },
  setFreeAdminFeeSegmentationConfig(state, segmentationConfig) {
    state.segmentationConfig = segmentationConfig;
  },
  setFreeAdminFeeMissionConfig(state, missionConfig) {
    state.missionConfig = missionConfig;
  },
  setFreeAdminFeeMissionLoading(state, loading) {
    state.loading = loading;
  },
  setFreeAdminFeeMissionJoining(state, joining) {
    state.joining = joining;
  },
};

export default {
  state: () => ({ ...initialState }),
  getters,
  actions,
  mutations,
};
